import React from "react"

import { AdvantageType, Variants } from "./types"
import {
  Cashback,
  LootMoney,
  Services,
  Mounth,
  Calendar,
  MounthWithoutTwelve,
  Rocket,
  Plus,
  Wallet,
  CashbackBlack,
  GrayTimer,
  GrayRuble,
  GrayCheck,
  GrayLightning,
} from "./images"

export const advantages: Record<Variants, AdvantageType[]> = {
  pkw: [
    {
      title: "До 17% на остаток",
      subtitle: "Дополнительный доход",
      img: <Mounth alt="MounthPayment image" />,
      required: true,
    },
    {
      title: "Кешбэк до 10%",
      subtitle: "На любые покупки",
      img: <Cashback alt="Services image" />,
      required: true,
    },
    {
      title: <>Обслуживание 0&nbsp;₽</>,
      subtitle: "Навсегда и без условий",
      img: <Services alt="Services image" />,
      required: true,
    },
    {
      title: <>До 500 000&nbsp;₽</>,
      subtitle: "На оплату покупок<br>и снятие наличных",
      img: <LootMoney alt="loot money image" />,
    },
  ],
  bezProcentov: [
    {
      title: "24 месяца без %",
      subtitle: "Срок рефинансирования",
      img: <Calendar alt="calendar image" />,
      required: true,
    },
    {
      title: <>До 500 000&nbsp;₽</>,
      subtitle: "На оплату покупок ",
      img: <LootMoney alt="loot money image" />,
      required: true,
    },
    {
      title: <>Обслуживание 0&nbsp;₽</>,
      subtitle: "Навсегда и без условий",
      img: <Services alt="Services image" />,
    },
    {
      title: "Без визита в банк",
      subtitle: "Оформление онлайн",
      img: <Mounth alt="cylinder image" />,
      required: true,
    },
  ],
  refin: [
    {
      title: "Рассрочка* на 24 месяца",
      subtitle: "С подпиской «Халва.Десятка»",
      img: <Calendar alt="calendar image" />,
      required: true,
    },
    {
      title: <>До 500 000&nbsp;₽</>,
      subtitle: "Максимальная сумма",
      img: <LootMoney alt="loot money image" />,
      required: true,
    },
    {
      title: <>Обслуживание 0&nbsp;₽</>,
      subtitle: "Навсегда и без условий",
      img: <Services alt="Services image" />,
    },
    {
      title: "Без визита в банк",
      subtitle: "Оформление онлайн",
      img: <Mounth alt="cylinder image" />,
      required: true,
    },
  ],
  refinZadolzhennostejMob: [
    {
      title: "Рассрочка* на 24 месяца",
      subtitle: "С подпиской «Халва.Десятка»",
      img: <Calendar alt="calendar image" />,
      required: true,
    },
    {
      title: <>До 500 000 рублей</>,
      subtitle: "Максимальная сумма",
      img: <LootMoney alt="loot money image" />,
      required: true,
    },
    {
      title: <>От 5 минут</>,
      subtitle: "Быстрое одобрение",
      img: <Services alt="Services image" />,
      required: true,
    },
    {
      title: "Без визита в банк",
      subtitle: "Оформление онлайн",
      img: <Mounth alt="cylinder image" />,
    },
  ],
  refinZadolzhennostej: [
    {
      title: (
        <>
          Рассрочка*
          <br />
          на 24 месяца
        </>
      ),
      subtitle: "С подпиской «Халва.Десятка»",
      img: <Calendar alt="calendar image" />,
      required: true,
    },
    {
      title: <>До 500 000 ₽</>,
      subtitle: "Максимальная сумма",
      img: <LootMoney alt="loot money image" />,
      required: true,
    },
    {
      title: <>От 5 минут</>,
      subtitle: "Быстрое одобрение",
      img: <Services alt="Services image" />,
      required: true,
    },
    {
      title: "Без визита в банк",
      subtitle: "Оформление онлайн",
      img: <Mounth alt="cylinder image" />,
    },
  ],
  refinMedia: [
    {
      title: <>24 месяца без&nbsp;%</>,
      subtitle: "Срок рефинансирования",
      img: <Calendar alt="calendar image" />,
      required: true,
    },
    {
      title: <>До 500 000&nbsp;рублей</>,
      subtitle: "Максимальная сумма",
      img: <LootMoney alt="loot money image" />,
      required: true,
    },
    {
      title: <>Обслуживание 0&nbsp;₽</>,
      subtitle: "Навсегда и без условий",
      img: <Services alt="Services image" />,
    },
    {
      title: "Без визита в банк",
      subtitle: "Оформление онлайн",
      img: <Mounth alt="cylinder image" />,
      required: true,
    },
  ],
  redisignBezProcentov: [
    {
      title: <>До 500 000&nbsp;₽</>,
      subtitle: "На оплату покупок ",
      img: <LootMoney alt="loot money image" />,
      required: true,
    },
    {
      title: "До 500 000 ₽",
      subtitle: "На рефинансирование",
      img: <Calendar alt="calendar image" />,
      required: true,
    },
    {
      title: <>Обслуживание 0&nbsp;₽</>,
      subtitle: "Навсегда и без условий",
      img: <Services alt="Services image" />,
    },
    {
      title: "Без визита в банк",
      subtitle: "Оформление онлайн",
      img: <MounthWithoutTwelve alt="cylinder image" />,
      required: true,
    },
  ],
  thirdAdvantagesPoints: [
    {
      title: <>Рефинансирование</>,
      subtitle: "В рассрочку на 24 месяца",
      img: <Calendar alt="calendar image" />,
      required: true,
    },
    {
      title: <>До 500 000&nbsp;₽</>,
      subtitle: "На оплату покупок ",
      img: <LootMoney alt="loot money image" />,
      required: true,
    },
    {
      title: <>Обслуживание 0&nbsp;₽</>,
      subtitle: "Навсегда и без условий",
      img: <Services alt="Services image" />,
    },
    {
      title: "Без визита в банк",
      subtitle: "Оформление онлайн",
      img: <MounthWithoutTwelve alt="cylinder image" />,
      required: true,
    },
  ],
  inviteFriend: [
    {
      title: <>Быстрое одобрение</>,
      subtitle: "За 5 минут",
      img: <Calendar alt="calendar image" />,
      required: true,
    },
    {
      title: <>До 500 000 ₽</>,
      subtitle: "Лимит рассрочки*",
      img: <LootMoney alt="loot money image" />,
      required: true,
    },
    {
      title: <>Обслуживание&nbsp;0&nbsp;₽</>,
      subtitle: "Навсегда и без условий",
      img: <Services alt="Services image" />,
      required: true,
    },
    {
      title: "Кешбэк до 10%",
      subtitle: "С каждой покупки",
      img: <MounthWithoutTwelve alt="cylinder image" />,
      required: true,
    },
  ],
  nedeliUmnyhRassrochek: [
    {
      title: <>Быстрое одобрение</>,
      subtitle: "За 5 минут",
      required: true,
      img: <Calendar alt="calendar image" />,
    },
    {
      title: <>До 500 000&nbsp;₽</>,
      subtitle: "На оплату покупок",
      required: true,
      img: <LootMoney alt="loot money image" />,
    },
    {
      title: <>Обслуживание 0&nbsp;₽</>,
      subtitle: "Навсегда и без условий",
      img: <Services alt="Services image" />,
    },
    {
      title: <>Без визита в банк</>,
      subtitle: "Оформление онлайн",
      img: <MounthWithoutTwelve alt="cylinder image" />,
      required: true,
    },
  ],
  newYear: [
    {
      title: <>До 500 000&nbsp;₽</>,
      subtitle: "на оплату покупок",
      img: <LootMoney alt="loot money image" />,
    },
    {
      title: "Обслуживание 0 ₽",
      subtitle: "Навсегда и без условий",
      img: <MounthWithoutTwelve alt="MounthPayment image" />,
      required: true,
    },
    {
      title: <>Кешбэк до 10%</>,
      subtitle: "от покупок",
      img: <Services alt="Services image" />,
      required: true,
    },
    {
      title: "17% на остаток",
      subtitle: "по карте",
      img: <Cashback alt="Services image" />,
      required: true,
    },
  ],

  productsCategories: [
    {
      title: <>Кешбэк до 10%</>,
      subtitle: "Покупайте с выгодой",
      img: <Cashback alt="Services image" />,
      required: true,
    },
    {
      title: <>До 500 тыс. рублей</>,
      subtitle: "лимит на покупки",
      img: <LootMoney alt="loot money image" />,
    },
    {
      title: <>Обслуживание 0&#160;₽</>,
      subtitle: "Навсегда и без условий",
      img: <Services alt="Services image" />,
      required: true,
    },
    {
      title: "Без визита в банк",
      subtitle: "Оформление онлайн",
      img: <Mounth alt="cylinder image" />,
      required: true,
    },
  ],
  halvaDlyaGamerov: [
    {
      title: <>Пополнение Steam</>,
      subtitle: "и других игровых кошельков",
      img: <Wallet alt="wallet image" />,
      required: true,
    },
    {
      title: (
        <>
          Кэшбэк
          <br /> и доп.рассрочка*
        </>
      ),
      subtitle: "в магазинах электроники",
      img: <CashbackBlack alt="cashback image" />,
      required: true,
    },
    {
      title: (
        <>
          Рассрочка* <br className="d-none d-desk-only-block" /> на покупки
        </>
      ),
      subtitle: "в онлайн-магазинах игр<br>и внутри онлайн-игр",
      img: <Plus alt="plus image" />,
      required: true,
    },
    {
      title: (
        <>
          Скидки на <br className="d-none d-desk-only-block" /> абонемент
        </>
      ),
      subtitle: "в компьютерные клубы,<br>покупка в рассрочку*",
      img: <Rocket alt="rocket image" />,
      required: true,
    },
  ],
  pkwBonus1500: [
    {
      title: <>Покупки в&nbsp;рассрочку*</>,
      img: <Calendar alt="calendar image" />,
      required: true,
    },
    {
      title: <>Кешбэк до 10%</>,
      img: <LootMoney alt="loot money image" />,
      required: true,
    },
    {
      title: <>Обслуживание 0&nbsp;₽</>,
      subtitle: "Навсегда и без условий",
      img: <Services alt="Services image" />,
    },
    {
      title: "До 500 000 ₽",
      subtitle: "Кредитный лимит на покупки",
      img: <MounthWithoutTwelve alt="cylinder image" />,
      required: true,
    },
  ],
  rassrochkaNaAuto: [
    {
      title: <>Рефинансирование</>,
      subtitle: "В рассрочку на 24 месяца",
      img: <Calendar alt="calendar image" />,
      required: true,
    },
    {
      title: "Более 260 000",
      subtitle: "Партнеров по всей России",
      img: <LootMoney alt="loot money image" />,
      required: true,
    },
    {
      title: <>Обслуживание 0&nbsp;₽</>,
      subtitle: "Навсегда и без условий",
      img: <Services alt="Services image" />,
    },
    {
      title: <>Без визита в&nbsp;банк</>,
      subtitle: "Оформление онлайн",
      img: <MounthWithoutTwelve alt="cylinder image" />,
      required: true,
    },
  ],
  land: [
    {
      title: "Более 260 000",
      subtitle: "Партнеров по всей России",
      img: <Calendar alt="calendar image" />,
      required: true,
    },
    {
      title: <>До 500 000 ₽</>,
      subtitle: "На оплату покупок",
      img: <LootMoney alt="loot money image" />,
    },
    {
      title: <>Обслуживание 0&nbsp;₽</>,
      subtitle: "Навсегда и без условий",
      img: <Services alt="Services image" />,
    },
    {
      title: <>Без визита в&nbsp;банк</>,
      subtitle: "Оформление онлайн",
      img: <MounthWithoutTwelve alt="cylinder image" />,
      required: true,
    },
  ],
  blackFridayHalva: [
    {
      title: "Быстрое одобрение",
      subtitle: "За 5 минут",
      img: <Calendar alt="calendar image" />,
      required: true,
    },
    {
      title: <>До 500 000&nbsp;₽</>,
      subtitle: "На оплату покупок ",
      img: <LootMoney alt="loot money image" />,
      required: true,
    },
    {
      title: <>Обслуживание 0&nbsp;₽</>,
      subtitle: "Навсегда и без условий",
      img: <Services alt="Services image" />,
    },
    {
      title: "Без визита в банк",
      subtitle: "Оформление онлайн",
      img: <MounthWithoutTwelve alt="cylinder image" />,
      required: true,
    },
  ],
  newYearMedia: [
    {
      title: "Быстрое одобрение",
      subtitle: "За 5 минут",
      img: <Calendar alt="calendar image" />,
      required: true,
    },
    {
      title: <>До 500 000&nbsp;₽</>,
      subtitle: "На оплату покупок ",
      img: <LootMoney alt="loot money image" />,
      required: true,
    },
    {
      title: <>Обслуживание 0&nbsp;₽</>,
      subtitle: "Навсегда и без условий",
      img: <Services alt="Services image" />,
    },
    {
      title: "Без визита в банк",
      subtitle: "Оформление онлайн",
      img: <MounthWithoutTwelve alt="cylinder image" />,
      required: true,
    },
  ],
  halvaMedia: [
    {
      title: "Рефинансирование",
      subtitle: "В рассрочку* на 24 месяца",
      img: <Calendar alt="calendar image" />,
      required: true,
    },
    {
      title: <>До 500 000&nbsp;₽</>,
      subtitle: "На оплату покупок ",
      img: <LootMoney alt="loot money image" />,
      required: true,
    },
    {
      title: <>Обслуживание 0&nbsp;₽</>,
      subtitle: "Навсегда и без условий",
      img: <Services alt="Services image" />,
    },
    {
      title: "Без визита в банк",
      subtitle: "Оформление онлайн",
      img: <MounthWithoutTwelve alt="cylinder image" />,
      required: true,
    },
  ],
  creditCardMedia: [
    {
      title: "Рефинансирование",
      subtitle: "на 24 месяца¹",
      img: <Calendar alt="calendar image" />,
      required: true,
    },
    {
      title: "Снятие наличных",
      subtitle: "без комиссии³",
      img: <LootMoney alt="loot money image" />,
      required: true,
    },
    {
      title: <>Обслуживание 0&nbsp;₽</>,
      subtitle: "навсегда и без условий",
      img: <Services alt="Services image" />,
    },
    {
      title: "300 дней",
      subtitle: "без процентов²",
      img: <MounthWithoutTwelve alt="cylinder image" />,
      required: true,
    },
  ],
  pkwCreditCard: [
    {
      subtitle: "на 24 месяца¹",
      title: "Рефинансирование",
      img: <Calendar alt="calendar image" />,
      required: true,
    },
    {
      title: "Снятие наличных",
      subtitle: "без комиссии³",
      img: <LootMoney alt="loot money image" />,
      required: true,
    },
    {
      title: <>Обслуживание 0&nbsp;₽</>,
      subtitle: "навсегда и без условий",
      img: <Services alt="Services image" />,
    },
    {
      title: "300 дней",
      subtitle: "без процентов²",
      img: <MounthWithoutTwelve alt="cylinder image" />,
      required: true,
    },
  ],
  pkwCreditCards: [
    {
      title: "Рефинансирование",
      subtitle: "на 24 месяца*",
      img: <Calendar alt="calendar image" />,
      required: true,
    },
    {
      title: "Снятие наличных",
      subtitle: "без комиссии**",
      img: <LootMoney alt="loot money image" />,
      required: true,
    },
    {
      title: <>Обслуживание 0&nbsp;₽</>,
      subtitle: "навсегда и без условий",
      img: <Services alt="Services image" />,
    },
    {
      title: "До 300 дней без %",
      subtitle: "с подпиской «Оптима»",
      img: <MounthWithoutTwelve alt="cylinder image" />,
      required: true,
    },
  ],
  creditCardMedia180Dnej: [
    {
      title: "Снятие наличных",
      subtitle: "без комиссии",
      img: <LootMoney alt="loot money image" />,
      required: true,
    },
    {
      title: <>Обслуживание 0&nbsp;₽</>,
      subtitle: "навсегда и без условий",
      img: <Services alt="Services image" />,
    },
    {
      title: "До 500 000 ₽",
      subtitle: "кредитный лимит",
      img: <MounthWithoutTwelve alt="cylinder image" />,
      required: true,
    },
  ],
  mediaD: [
    {
      title: "Рассрочка*",
      subtitle: "От 10 мес.",
      img: <Calendar alt="calendar image" />,
      required: true,
    },
    {
      title: "Кешбэк",
      subtitle: "До 10%",
      img: <LootMoney alt="loot money image" />,
      required: true,
    },
    {
      title: "До 17%",
      subtitle: "На остаток",
      img: <Services alt="Services image" />,
    },
    {
      title: "Обслуживание 0 ₽",
      subtitle: "Навсегда и без условий",
      img: <MounthWithoutTwelve alt="cylinder image" />,
      required: true,
    },
  ],
  planetaCard: [
    {
      title: "Быстрое одобрение",
      subtitle: "За 5 минут",
      img: <Calendar alt="calendar image" />,
      required: true,
    },
    {
      title: <>Более 260 000</>,
      subtitle: "Партнеров по&nbsp;всей&nbsp;стране",
      img: <LootMoney alt="loot money image" />,
      required: true,
    },
    {
      title: <>Обслуживание 0&nbsp;₽</>,
      subtitle: "Навсегда и без условий",
      img: <Services alt="Services image" />,
    },
    {
      title: "+ 1 месяц",
      subtitle: "Доп.рассрочки* в&nbsp;ТРЦ&nbsp;«Планета»",
      img: <MounthWithoutTwelve alt="cylinder image" />,
      required: true,
    },
  ],
  aura: [
    {
      title: "Быстрое одобрение",
      subtitle: "За 5 минут",
      img: <Calendar alt="calendar image" />,
      required: true,
    },
    {
      title: <>Более 260 000</>,
      subtitle: "Партнеров по всей стране",
      img: <LootMoney alt="loot money image" />,
      required: true,
    },
    {
      title: <>Обслуживание 0&nbsp;₽</>,
      subtitle: "Навсегда и без условий",
      img: <Services alt="Services image" />,
    },
    {
      title: "+ 1 месяц",
      subtitle: "Доп.рассрочки* в&nbsp;ТРЦ&nbsp;«Аура»",
      img: <MounthWithoutTwelve alt="cylinder image" />,
      required: true,
    },
  ],
  special: [
    {
      title: "Быстрое одобрение",
      subtitle: "За 5 минут",
      img: <Calendar alt="calendar image" />,
      required: true,
    },
    {
      title: <>Более 260 000</>,
      subtitle: "Партнеров по всей стране",
      img: <LootMoney alt="loot money image" />,
      required: true,
    },
    {
      title: <>Обслуживание 0&nbsp;₽</>,
      subtitle: "Навсегда и без условий",
      img: <Services alt="Services image" />,
    },
    {
      title: "+ 1 месяц",
      subtitle: "Доп.рассрочки* в&nbsp;ТРК&nbsp;«ЛЕТО»",
      img: <MounthWithoutTwelve alt="cylinder image" />,
      required: true,
    },
  ],
  plait: [
    {
      title: "Решение за\u00A05\u00A0минут",
      subtitle: "Без долгих ожиданий",
      img: <GrayTimer alt="clock image" />,
      required: true,
    },
    {
      title: <>До 500 000&nbsp;₽</>,
      subtitle: "На оплату покупок ",
      img: <GrayRuble alt="ruble image" />,
      required: true,
    },
    {
      title: <>Обслуживание 0&nbsp;₽</>,
      subtitle: "Навсегда и без условий",
      img: <GrayCheck alt="Checked image" />,
    },
    {
      title: "Без визита в банк",
      subtitle: "Оформление онлайн",
      img: <GrayLightning alt="distance image" />,
      required: true,
    },
  ],
  newStickers: [
    {
      title: <>Кэшбек до&nbsp;10%</>,
      subtitle: `С подпиской «Халва.Десятка»`,
      img: <LootMoney alt="loot money image" />,
      required: true,
    },
    {
      title: "Платите телефоном",
      subtitle: "Как и\u00A0привыкли",
      img: <Calendar alt="calendar image" />,
      required: true,
    },
    {
      title: <>Более 260&nbsp;000</>,
      subtitle: "Магазинов-партнёров",
      img: <Services alt="Services image" />,
    },
    {
      title: "Яркие дизайны",
      subtitle: "Стильно и красиво",
      img: <MounthWithoutTwelve alt="cylinder image" />,
      required: true,
    },
  ],
  creditCardGet: [
    {
      title: "Рефинансирование",
      subtitle: "на 24 месяца*",
      img: <Calendar alt="calendar image" />,
      required: true,
    },
    {
      title: "Снятие наличных",
      subtitle: "без комиссии**",
      img: <LootMoney alt="loot money image" />,
      required: true,
    },
    {
      title: <>Обслуживание 0&nbsp;₽</>,
      subtitle: "навсегда и без условий",
      img: <Services alt="Services image" />,
    },
    {
      title: "10 месяцев",
      subtitle: "беспроцентный период***",
      img: <MounthWithoutTwelve alt="Mounth Without Twelve" />,
      required: true,
    },
  ],
  zhkh: [
    {
      title: <>2 промокода в&nbsp;подарок</>,
      subtitle: "На ЖКХ и Супермаркеты",
      img: <LootMoney alt="loot money image" />,
      required: true,
    },
    {
      title: <>Быстрое&nbsp;одобрение</>,
      subtitle: "За 5 минут",
      img: <Calendar alt="calendar image" />,
      required: true,
    },
    {
      title: <>Обслуживание 0&nbsp;₽</>,
      subtitle: "Навсегда и без условий",
      img: <Services alt="Services image" />,
    },
    {
      title: <>Без визита в банк</>,
      subtitle: "Оформление онлайн",
      img: <LootMoney alt="loot money image" />,
      required: true,
    },
  ],
}
